
import cleanSku from '@util/cleanSku';
import {toProductUrl} from '@util/URLUtils';
import SizedImage from '../../common/SizedImage';
import Icon from '../../common/Icon';
import Item from './Item';
import dataLayer from '@upi/data-layer';
import {isCanonicalItemList} from '@upi/data-layer-constants';

const cls = {
    root: 'flex py-2 px-4 border-b border-solid border-grey-lighter',
    left: 'flex-0 w-24',
    right: 'flex-1 w-px pl-2',
    thumbnail: 'block border border-solid border-grey-lighter bg-white',
    title: 'ellipsis leading-normal my-0 text-sm',
    detail: 'my-0 text-sm',
    after: 'pl-2 self-center'
};

const ItemProduct = (
    {sku, longName, shortName, indicator, url, index, queryGroup, itemList, className = '', onClick, ...props},
    {conf}
) => {
    const attrs = {};
    const skuDisplay = cleanSku( sku );
    const isEcommerceSite = conf.isEcommerceSite;
    const position = Number.isInteger( index ) ? index + 1 : undefined;
    const hasItemList = isCanonicalItemList( itemList ) && (!queryGroup || queryGroup.analyticsProducts);

    if ( isEcommerceSite ) {
        attrs['data-quick-view'] = true;
        attrs['data-sku'] = sku;
        if ( hasItemList ) {
            attrs['data-item-list-id'] = itemList.id;
            attrs['data-item-list-name'] = itemList.name;
        }
    }

    const handleClick = event => {
        if ( hasItemList ) {
            dataLayer.product.sendProductClick( {
                sku,
                kitName: longName,
                position
            }, {itemList} );
        }
        if ( typeof onClick === 'function' ) {
            onClick( event );
        }
    };

    if ( url ) {
        attrs.href = toProductUrl( {
            path: url,
            sku: skuDisplay
        } )
    }

    return (
        <Item className={[cls.root, className].join( ' ' )}
              {...attrs}
              onClick={handleClick}
              {...props}>
            <div className={cls.left}>
                <div className="img-ratio-4x3">
                    <SizedImage type="sku" src={sku} alt={longName} className={cls.thumbnail}/>
                </div>
            </div>
            <div className={cls.right}>
                <h4 className={cls.title}>{longName}</h4>
                <p className={cls.detail}>{indicator} #{skuDisplay}</p>
            </div>
            {isEcommerceSite ?
                <div className={cls.after}>
                    <Icon.ui name="shopping-cart-add" className="text-xl"/>
                </div>
                : null
            }
        </Item>
    );
};

export default ItemProduct;
